import { FunctionalComponent, h } from '@stencil/core';
import { AppRTE } from './app.rte';

interface SectionFormCompetition {
    __component: string;
    data?: any;
}


export const SectionFormCompetition: FunctionalComponent<SectionFormCompetition> = ({data}) => {

    const {Title, Description} = data;

    return (
        <section id='form-competition' class="uk-position-relative uk-container uk-container-large">
            <div class="uk-section uk-padding-small uk-padding@s uk-background-primary-striped uk-position-relative" style={{ 'min-height': 'calc(100vh - 176px)' }}>
                <div class="uk-container uk-position-relative">
                    <div class="uk-child-width-1-1 uk-grid-collapse" uk-grid>
                        <div class="uk-width-1-1 uk-width-1-2@l">
                            <div class="uk-light uk-padding@s">
                                <h2 class="uk-heading-small wsio-gold uk-margin-small-bottom">Competition Entry</h2>
                                <h3 class="uk-heading-xlarge uk-margin-remove-top uk-margin-medium-bottom">{`${Title || 'Competition'}`}</h3>
                                <AppRTE markdown={Description}/>
                            </div>
                        </div>
                        <div class="uk-width-1-1 uk-width-2-3@m uk-width-1-2@l">
                            <div>
                                <div class="uk-shadow-flat uk-padding-small uk-padding@s uk-background-white">
                                    <app-form-competition />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};